import { Answer } from "./types";

export const HIDDEN_ANSWER_TYPES: Answer["type"][] = [
  "Conditions",
  "Hidden Value",
  "Redirect",
  "Question Group",
] as const;
